import { render, staticRenderFns } from "./ParagraphControl.vue?vue&type=template&id=a71a577e&scoped=true"
import script from "./ParagraphControl.vue?vue&type=script&lang=js"
export * from "./ParagraphControl.vue?vue&type=script&lang=js"
import style0 from "./ParagraphControl.vue?vue&type=style&index=0&id=a71a577e&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a71a577e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data01/test/dev.console.insureforce.cn/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a71a577e')) {
      api.createRecord('a71a577e', component.options)
    } else {
      api.reload('a71a577e', component.options)
    }
    module.hot.accept("./ParagraphControl.vue?vue&type=template&id=a71a577e&scoped=true", function () {
      api.rerender('a71a577e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/examine/auditManage/components/ParagraphControl.vue"
export default component.exports